import { useParams } from 'react-router'
import dayjs from 'dayjs'
import { useCheckRole } from 'auth'
import { userTypes, ErrorBoundary } from 'shared'

import { PageTitle } from '../../../_metronic/layout/core'
import { CampaignForm } from '../components/create-campaign/CampaignForm'
import { Spinner } from 'react-bootstrap'
import { useCampaign } from '../hooks'
import { isIntentReportConfiguration } from '../models/Campaign'

type Props = { campaignId: number }
export const EditCampaignPage = (props: Props) => {
  const { status, data: campaign, error } = useCampaign(props.campaignId)

  if (status === 'idle' || status === 'loading')
    return (
      <>
        <PageTitle>Edit Campaign</PageTitle>
        <div className='d-flex align-items-center justify-content-center'>
          <Spinner animation='grow'></Spinner>
        </div>
      </>
    )

  if (status === 'error' || campaign === undefined)
    return (
      <>
        <PageTitle>Edit Campaign</PageTitle>
        <span>Error: {(error as any).message}</span>
      </>
    )

  const campaignDTO = {
    ...campaign.objective,
    id: campaign.id,
    client: Number(campaign.client.id),
    name: campaign.name,
    description: campaign.description,
    startDate: dayjs(campaign?.startDate).format('YYYY-MM-DD'),
    endDate: campaign?.endDate ? dayjs(campaign?.endDate).format('YYYY-MM-DD') : null,
    isDataIntelligenceActive: !!campaign.objective?.isDataIntelligenceActive,
    isTeleProspectingActive: !!campaign.objective?.isTeleProspectingActive,
    isDigitalProspectingActive: !!campaign.objective?.isDigitalProspectingActive,
    status: campaign.status,
    clientId: campaign.client?.id,
    lookerClientId: campaign.lookerClientId ? Number(campaign.lookerClientId) : null,
    intentReportConfigurations: campaign.intentReportConfigurations.map(
      // TODO: see Q in models.Campaign, this shouldn't be necessary
      (iRC) =>
        isIntentReportConfiguration(iRC)
          ? { accountType: iRC.accountType, reportId: iRC.configuration.reportId }
          : iRC
    ),
    icps: campaign.icps.map((icp) => {
      return {
        id: icp.id,
        name: icp.name,
        industryId: icp.industryId,
        revenueRangeId: icp.revenueRangeId,
        employeeRangeId: icp.employeeRangeId,
      }
    }),
  }

  return (
    <>
      <PageTitle>Edit Campaign</PageTitle>
      <CampaignForm type='edit' campaign={campaignDTO} campaignId={props.campaignId} />
    </>
  )
}

const Controller = () => {
  useCheckRole([userTypes.Admin, userTypes.ClientManager, userTypes.CampaignManager])

  const params: any = useParams()
  const campaignId = Number(params?.id)

  return <EditCampaignPage campaignId={campaignId} />
}

export const EditCampaignPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
